<template>
      <div class="dashboard-icon" v-on:click="goToDashboard">
          <i class="fa fa-dashboard" /> Dashboard
      </div>
</template>

<script>
import { mapState } from "vuex";
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccntCustomer',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { 
        itemsCount: 42 ,
        username: ""
      }
  },
   computed: {
    ...mapState("login", ["user_name","access_token"]),

    isLogged() {
       return this.access_token !== null;
    }

  },
  mounted() {
    if(this.user_name != ""){
        this.username = this.user_name;
    }
  },
  methods: {
    goToDashboard() {
      this.$router.push({
        name: 'ProposalListCustomer', query: {
          uuid: this.$route.query.uuid,
          is_final: this.$route.query.is_final
        }
      })
    }
  },
}
</script>

<style scoped>

  .app-header .dropdown-menu {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.05), 0 6px 8px 0 rgba(0, 0, 0, 0.05);
    border-bottom: 0px solid #c8ced3 !important;
    border-radius: 0.25rem;
  }

  .dashboard-icon{
    color: white;
    margin-right: 12px;
  }

  .dashboard-icon{
    color: white;
    margin-right: 12px;
    cursor: pointer;
  }
</style>